import React, { useState, useContext, useEffect } from "react";
import LoginContext from "./components/context/LoginContext";
import "./index.css";

function TestButton() {
  const { itemList } = useContext(LoginContext);
  const [quantity, setQuantity] = useState(1);
  const [selectedItem, setSelectedItem] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    console.log("Current Quantity:", quantity); // Debugging the quantity value
  }, [quantity]);

  // Add item to cart and show the modal
  const handleAddToCart = (item) => {
    setSelectedItem(item);
    setQuantity(1);  // Reset quantity to 1 when adding a new item
    setIsModalOpen(true); // Show modal
  };

  // Handle Increment/Decrement of Quantity
  const handleQuantityChange = (change) => {
    setQuantity((prevQuantity) => {
      const newQuantity = prevQuantity + change;
      return newQuantity >= 1 ? newQuantity : 1; // Ensure quantity doesn't go below 1
    });
  };

  // Handle Manual Input Change
  const handleQuantityInputChange = (e) => {
    const inputValue = e.target.value;
    const parsedValue = parseInt(inputValue, 10);

    if (!isNaN(parsedValue) && parsedValue >= 1) {
      setQuantity(parsedValue); // Set quantity if valid
    } else if (inputValue === "") {
      setQuantity(1); // Reset to 1 if input is empty
    }
  };

  // Close the modal
  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <section id="secondpart">
        <div className="uk-container uk-margin-small-top">
          <div className="uk-grid uk-grid-medium" uk-grid>
            <div className="uk-width-expand@s">
              <div className="uk-grid uk-child-width-1-1@s uk-grid-match uk-grid-small" uk-grid>
                {itemList && itemList.length > 0 ? (
                  itemList.map((item, index) => (
                    <div key={index}>
                      <div className="uk-card uk-card-default uk-flex uk-margin">
                        <img src={item.Image} alt="Item" />
                        <div className="uk-card-body">
                          <div className="uk-text-right">
                            <button
                              className="uk-button uk-button-default"
                              onClick={() => handleAddToCart(item)}
                            >
                              Add to Cart
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <p>No items available</p>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* React Modal */}
        {isModalOpen && (
  <div className="react-modal-overlay">
    <div className="react-modal-dialog">
      <button className="react-modal-close" onClick={closeModal}>X</button>
      <div className="react-modal-header">
        <h2 className="react-modal-title">
          {selectedItem ? selectedItem.Name : "Item Name"}
        </h2>
      </div>
      {selectedItem && (
        <div className="react-modal-body">
          <div className="modal-content">
            <div className="modal-image">
              <img src={selectedItem.Image} alt="Item" />
            </div>
            <div className="modal-details">
              <span>{selectedItem.Name}</span>
              <span className="modal-rate">{selectedItem.Rate}</span>
            </div>
          </div>

          <div className="quantity-selector">
            <label htmlFor="quantity">Quantity:</label>
            <button onClick={() => handleQuantityChange(-1)} disabled={quantity === 1}>-</button>
            <input
              id="quantity"
              type="text"
              value={quantity}
              readOnly
            />
            <button onClick={() => handleQuantityChange(1)}>+</button>
          </div>

          <p><strong>Subtotal:</strong> {quantity * selectedItem.Rate}</p>

          <div className="modal-footer">
            <button>Add Now</button>
          </div>
        </div>
      )}
    </div>
  </div>
)}

      </section>
    </>
  );
}

export default TestButton;
